import { render, staticRenderFns } from "./HeaderModal.vue?vue&type=template&id=620f6df7&scoped=true&lang=pug&"
import script from "./HeaderModal.vue?vue&type=script&lang=js&"
export * from "./HeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderModal.vue?vue&type=style&index=0&id=620f6df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f6df7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
